import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { IManagableObject } from "../../../admin-panel/IManagableObject";

declare const $;

@Component({
    selector: 'app-group-filter',
    templateUrl: './group-filter.component.html',
    styleUrls: ['./group-filter.component.css'],
    standalone: false
})
export class GroupFilterComponent implements AfterViewInit, OnInit {

  @Input()
  public groups: IManagableObject[] = [];

  @Input()
  public isEditable: boolean = true;

  public groupNameFilter: string;

  public allGroupsItem: IManagableObject = new class implements IManagableObject {
    Id: number;
    IsChecked: boolean;
    Name: string;
  };
  public selectedGroup: IManagableObject = this.allGroupsItem;


  @Output() onAddGroup: EventEmitter<any> = new EventEmitter();
  @Output() onEditGroup: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteGroup: EventEmitter<any> = new EventEmitter();
  @Output() onSelectGroup: EventEmitter<any> = new EventEmitter();

  public onTermChange(term: Event) {
    const input = event.target as HTMLInputElement;
    this.groupNameFilter = input.value;
  }

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.translate.onLangChange.subscribe(() =>
      this.allGroupsItem.Name = this.translate.instant("All"));
    this.allGroupsItem.Id = -1;
  }

  ngAfterViewInit() {
    $(document).trigger("readyAgain");
  }

  public openMgmtDropdown(group: any, event: any) {
    this.groups.forEach((grp:any) => {
      if (grp.Id == group.Id) {
        group.isMgmtOpen = !group.isMgmtOpen;
        group.mgmtyPos = event.clientY + 10;
        group.mgmtxPos = event.clientX + 10;
      } else {
        grp.isMgmtOpen = false;
      }
    });
  }

  public addGroup() {
    this.onAddGroup.emit();
  }

  public editGroup(group: IManagableObject) {
    this.onEditGroup.emit(group);
  }

  public deleteGroup(group: IManagableObject) {
    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + group.Name + "?")) return;
    if (this.selectedGroup == group)
      this.selectGroup(this.allGroupsItem);
    this.onDeleteGroup.emit(group);
  }

  public selectGroup(group: IManagableObject) {
    this.selectedGroup = group;
    this.onSelectGroup.emit(group);
  }

}

